import { Link } from "react-router-dom";
import translate from './../../../Translate/loginRegister.json'; 
export const Success = ({language}) => {
    return(
        <div className="modal-window">
            <div className="error-block"> 
                <div className="error-massage">
                    <h1>{translate.register.message.title[language]}</h1>
                    <p>password changed</p>
                    <Link className="error-btn" to='/login'>{translate.register.message.button[language]}</Link>
                </div>
            </div>
        </div>
    )
}